import { FrameCacheEvent } from '../types';
var EventEmitter = (function () {
    function EventEmitter() {
    }
    EventEmitter.on = function (name, listener) {
        if (!EventEmitter._events[name]) {
            EventEmitter._events[name] = [];
        }
        EventEmitter._events[name].push(listener);
    };
    EventEmitter.onSingle = function (name, listener) {
        EventEmitter._events[name] = [listener];
    };
    EventEmitter.removeListener = function (name, listener) {
        if (!EventEmitter._events[name]) {
            throw new Error("Can't remove a listener. Event \"" + name + "\" doesn't exits.");
        }
        var filterListeners = function (f) { return f !== listener; };
        EventEmitter._events[name] = EventEmitter._events[name].filter(filterListeners);
    };
    EventEmitter.emit = function (name, data) {
        if (!EventEmitter._events[name]) {
            return;
        }
        var fireCallbacks = function (callback) {
            callback(data);
        };
        EventEmitter._events[name].forEach(fireCallbacks);
    };
    EventEmitter.emitModelUpdate = function (update) {
        EventEmitter.emit(FrameCacheEvent.ModelUpdate, update);
    };
    EventEmitter.emitState = function (state) {
        EventEmitter.emit(FrameCacheEvent.State, state);
    };
    EventEmitter.emitAnalytics = function (analytics) {
        EventEmitter.emit(FrameCacheEvent.Analytics, analytics);
    };
    EventEmitter._events = {};
    return EventEmitter;
}());
export { EventEmitter };
//# sourceMappingURL=event-emitter.js.map